import store from '@/store'

export default {
  inserted(el, binding) {
    const { value } = binding
    const roles = store.getters && store.getters.roles
    const permissions = store.getters && store.getters.permissions
    if (value && value instanceof Array) {
      if (value.length > 0) {
        const permissionRoles = value
        let hasPermission = roles.some(role => {
          return permissionRoles.includes(role)
        })
        if (!hasPermission) {
          hasPermission = permissions.some(role => {
            return permissionRoles.includes(role)
          })
        }
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el)
        }
      }
    } else {
      throw new Error(`使用方式： v-permission="['admin','editor']"`)
    }
  }
}
